import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const ModalPopupWrapper = () => {
  const popupData = useSelector((state: any) => state.popup?.messagePopup)
  const [open,] = useState<boolean>(false)
  useEffect(() => {
    console.log('popupData : ', popupData)
  }, [popupData])
  return (
    <div>
      <Modal show={open}></Modal>
    </div>
  )
}

export default ModalPopupWrapper
